module.exports = __webpack_public_path__ + "static/img/uos-icon.ef9b8f30.png";